import React from 'react'
import { FilterProvider } from '../context/FilterContext';
import { ClientProvider } from '../context/ClientContext';
import { UserProvider } from '../context/UserContext';
import { FranchiseeProvider } from '../context/FranchiseeContext';
import { SelectedFranchiseeProvider } from '../context/SelectedFranchiseeContext';
import { useLocation } from 'react-router-dom';
import isTokenExpired from '../utilities/checkTokenExpiration';

// Component to conditionally render data-fetching providers
const AuthenticatedProviders = ({ children }) => {
  const location = useLocation();
  const isPublicRoute = location.pathname === '/magic-link-request' || 
                         location.pathname.startsWith('/auth/login/');
  
  // If token is expired or we're on a public route, don't render data providers
  if (isTokenExpired() || isPublicRoute) {
    return children;
  }

  // Only render data providers if authenticated
  return (
    <FranchiseeProvider>
      <ClientProvider>
        {children}
      </ClientProvider>
    </FranchiseeProvider>
  );
};

export default function Providers({children}) {
  return (
    // FilterProvider doesn't make API calls, so it can be rendered always
    <FilterProvider>
      {/* UserProvider is needed for login, but other providers aren't */}
      <UserProvider>
        <SelectedFranchiseeProvider>
          <AuthenticatedProviders>
            {children}
          </AuthenticatedProviders>
        </SelectedFranchiseeProvider>
      </UserProvider>
    </FilterProvider>
  )
}
